var map = {
	"./ic-alert.svg": "6dfc",
	"./ic-arrow-down-red.svg": "a679",
	"./ic-arrow-right-white.svg": "5c2c",
	"./ic-arrow-up-orange.svg": "95ce",
	"./ic-arrow-up.svg": "a284",
	"./ic-back-arrow-gray.svg": "a411",
	"./ic-back-arrow.svg": "8cea",
	"./ic-chains-black.svg": "f237",
	"./ic-chart-bar.svg": "27d1",
	"./ic-chart-trend.svg": "e6d9",
	"./ic-check.svg": "57f8",
	"./ic-comment.svg": "b976",
	"./ic-date.svg": "55e8",
	"./ic-diamond-black.svg": "7a7a",
	"./ic-download.svg": "c77d",
	"./ic-fire.svg": "eb47",
	"./ic-flag-black.svg": "92b3",
	"./ic-flag-green.svg": "3b4a",
	"./ic-flag.svg": "38e7",
	"./ic-gantt.svg": "d874",
	"./ic-gear.svg": "03bc",
	"./ic-gemestone-black.svg": "9233",
	"./ic-incoming.svg": "8af8",
	"./ic-info.svg": "94f8",
	"./ic-invoice-black.svg": "b784",
	"./ic-invoice.svg": "bfb1",
	"./ic-lightning-black.svg": "cd66",
	"./ic-list-black.svg": "7839b",
	"./ic-message.svg": "b3e2",
	"./ic-move-black.svg": "dbe0",
	"./ic-new-product-green.svg": "dfc5",
	"./ic-next-arrow-gray.svg": "7179",
	"./ic-next-arrow.svg": "a3c0",
	"./ic-open-link-black.svg": "73d5",
	"./ic-open-link.svg": "fa69",
	"./ic-outgoing.svg": "1807",
	"./ic-package-slip-white.svg": "4b19",
	"./ic-package-slip.svg": "cba1",
	"./ic-packaging.svg": "51a2",
	"./ic-photo.svg": "57f9",
	"./ic-pie.svg": "0d04",
	"./ic-po.svg": "f216",
	"./ic-purchase-orders.svg": "6da2",
	"./ic-quality-check-black.svg": "3531",
	"./ic-quality-check-gray.svg": "088d",
	"./ic-quality-check-green.svg": "f2ea",
	"./ic-quality-check.svg": "8ae6",
	"./ic-rejected2.svg": "63e0",
	"./ic-reload.svg": "e561",
	"./ic-risk.svg": "a0c3",
	"./ic-sdc.svg": "8eaf",
	"./ic-shipment-black.svg": "2288",
	"./ic-shipment-green.svg": "2bfc",
	"./ic-shipment-outgoing.svg": "dfd6",
	"./ic-shipment.svg": "a853",
	"./ic-star-off.svg": "e48e",
	"./ic-star.svg": "e7ea",
	"./ic-time-black.svg": "7c4d",
	"./ic-time-green.svg": "4ff1",
	"./ic-time-grey.svg": "642c",
	"./ic-tool.svg": "5222",
	"./ic-upload-file.svg": "8fb1",
	"./ic-warning.svg": "5c48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c64";